// © Microsoft Corporation. All rights reserved.
export interface SocialBarData {
    totalCommentsCount?: number;
    reactionCounts?: {
        sad?: number;
        like?: number;
        surprised?: number;
        angry?: number;
        love?: number
        thinking?: number;
    },
    id: string;
    myReaction?: string;
}

export interface SocialBarLocalizedStrings {
    ariaLabelsOpenReplies?: string;
    emojiLabellike?: string;
    emojiLabellove?: string;
    emojiLabelsurprised?: string;
    emojiLabelthinking?: string;
    emojiLabelsad?: string;
    emojiLabelangry?: string;
    thousandsShort?: string;
    reactionMenuAriaLabel?: string;
    ariaLabelShowReactions?: string;
    ariaLabelReactions?: string;
    ariaLabelCommentsCount?: string;
    ariaLabelReactionsCount?: string;
    ariaLabelReactionButtonSingular?: string;
    ariaLabelReactionButtonPlural?: string;
}

export enum SocialReactions {
    like = "like",
    love = "love",
    surprised = "surprised",
    thinking = "thinking",
    sad = "sad",
    angry = "angry"
}